/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Changepassword1Inputs */

const de__field_changepassword1 = /** @type {(inputs: _Field_Changepassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort ändern`)
};

/**

* @param {_Field_Changepassword1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_changepassword1 = /** @type {((inputs?: _Field_Changepassword1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Changepassword1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_changepassword1(inputs)
});
export { _field_changepassword1 as "_field_changePassword" }